import { Badge, NumberFormatter } from "@mantine/core";

function ratingColor(rating: number) {
  if (rating === 0) {
    return "gray";
  } else if (rating >= 8) {
    return "green";
  } else if (rating >= 7) {
    return "lime";
  } else if (rating >= 6.5) {
    return "yellow";
  } else if (rating >= 6) {
    return "orange";
  } else {
    return "red";
  }
}

function ratingVariant(rating: number | null | undefined) {
  if (rating === 0 || !rating) {
    return "light";
  }
  return "filled";
}

export function PlayerRating({
  rating,
}: {
  rating: string | number | null | undefined;
}) {
  const displayRating = rating ? Number(rating) : 0;
  return (
    <Badge
      style={{ fontFamily: "monospace" }}
      title={`Rating: ${rating}`}
      color={ratingColor(displayRating)}
      variant={ratingVariant(displayRating)}
    >
      <NumberFormatter
        value={displayRating}
        decimalScale={1}
        fixedDecimalScale
      />
    </Badge>
  );
}
